module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Récompenses Carte de crédit',
        moreLink: 'Voir plus',
        listTitle: 'Récompenses Carte de crédit obtenues',
        creditCardReward: 'Récompense Carte de crédit',
        view: 'Afficher',
        more: 'voir plus',
        modalButton: 'Compris'
    };

    return resources[label];
};
